var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"text-center"},[(!_vm.displayAvgFeedback)?_c('OneByOneComponentRenderer',{attrs:{"components":_vm.feedbackComponents},on:{"lastIndexReached":(arg) => {
        if (arg.reached) {
          this.$emit('displayRedirect', true);
        }
      }}}):_vm._e(),(_vm.displayAvgFeedback)?_c('OneByOneComponentRenderer',{attrs:{"components":_vm.feedbackComponentsAvg},on:{"lastIndexReached":(arg) => {
        if (arg.reached) {
          this.$emit('displayRedirect', true);
        }
      }}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }